/**
 * @deprecated
 */
export default function TableComponent() {
  const DESCENDING_TEXT = 'DESC';
  const ASCENDING_TEXT = 'ASC';

  let onSort = (sortBy, orderBy) => { console.log(`${sortBy} ${orderBy}`)};
  let selectedSortBy = '';
  let selectedOrderBy = '';

  const flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT;
  }

  const onSortClick = (sortBy) => () => {
    if (selectedSortBy === sortBy) {
      selectedOrderBy = flipOrderText(selectedOrderBy);
    } else {
      selectedSortBy = sortBy;
      selectedOrderBy = DESCENDING_TEXT;
    }
    onSort(selectedSortBy, selectedOrderBy);
  };

  const getSortIcon = (sortBy) => {
    if (selectedSortBy !== sortBy) {
      return null;
    }

    return selectedOrderBy === DESCENDING_TEXT
      ? m('i.bi.bi-sort-down', { "style": "float:left" })
      : m('i.bi.bi-sort-up', { "style": "float:left" });
  };

  const getHeaders = (headers) => {
    return headers.map((h) => m("th",
      {
        scope: 'col',
        style: {
          'background-color': h.highlight ? 'LightYellow' : '',
          'cursor': h.orderBy ? 'pointer' : ''
        },
        onclick: h.orderBy ? onSortClick(h.orderBy) : null
      },
      h.orderBy ? getSortIcon(h.orderBy) : null,
      h.label
    ));
  }

  return {
    oninit: ({ attrs }) => {
      onSort = attrs.onSort ?? onSort;
      selectedSortBy = attrs.orderBy ?? selectedSortBy;
      selectedOrderBy = attrs.sortBy ?? selectedOrderBy;
    },
    view: ({ attrs }) => {
      let id = attrs.id;
      let headers = attrs.headers;
      let details = attrs.details;
      let buttons = attrs.buttons;
      let pagination = attrs.pagination;

      if (attrs.isNested) {
        return [
          m("div", { "class": "accordion-collapse collapse px-2", "id": "gc_collapse_" + id },
            m("table", { "class": "table table-bordered nested-table m-0 p-0" },
              [
                m("thead", { "class": "nested-thead" },
                  m("tr", { "class": "align-middle" }, getHeaders(headers))
                ),
                m("tbody", details, buttons),
              ])
          ),
          pagination
        ];
      } else {
        return [m("div", { "class": "table-responsive" },
          m("table", { "class": "table table-striped", "style": { "width": "100%" } },
            [
              m("thead",
                m("tr", { "class": "align-middle" }, getHeaders(headers))
              ),
              m("tbody", details, buttons),
            ])
        ), pagination];
      }
    },
  };
}
